module.exports = __webpack_public_path__ + "img/ic24EmailBlack.69eb62ab.svg";